import { Box, Typography, styled } from '@mui/material'
import {Search , MoreVert} from '@mui/icons-material'
import React, { useEffect, useState } from 'react'
import { useChatContex } from '../../../contex/ChatContex'



const Header=styled(Box)`
height:44px;
background:#ededed;
display:flex;
align-items:center;
`


const Imgae=styled('img')({
    height:40,
    width:40,
    objectFit:'cover',
    borderRadius:"50%",

})

const RightContainer=styled(Box)`
margin-left:auto;
& > svg{
    padding:8px;
    font-size:24px;
    color:#000;
}
`
const Name=styled(Typography)`
margin-left:12px !important;

`
const Status=styled(Typography)`
margin-left:12px !important;
font-size:12px
`







function ChatHeader() {


const {PersonData,socket,login} = useChatContex()

const[ActiveUser,SetActiveUser]=useState([])

useEffect(()=>{


     socket.current.on("getUser",user=>{
          SetActiveUser(user)
      })
},[login])

    return (
        <Header>
            <Imgae src={PersonData.img}></Imgae>
            <Box>
                <Name>{PersonData.name}</Name>
                <Status> {ActiveUser?.find(user=>user.sub === PersonData.sub)?'Online':'Offline'} </Status>
            </Box>
            <RightContainer>
                <Search/>
                <MoreVert/>
            </RightContainer>
        </Header>
    )
}

export default ChatHeader
